import { FC } from 'react'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'

import cn from './index.module.css'
import { IUserNote } from '@common/Notes/utils/types'
import classNames from 'classnames'

interface INoteCard {
  note: IUserNote
  className?: string
  onClick: () => void
  onRemove: () => void
}

const NoteCard: FC<INoteCard> = ({ note, className, onClick, onRemove }) => {
  return (
    <div className={classNames(cn.wrapper, className)}>
      <div className={cn.content}>
        <div className={cn.title}>{note.title}</div>
        <p className={cn.text}>{note.text}</p>
      </div>
      <div className={cn.actions}>
        <button className={classNames(cn.actionButton)} onClick={onClick}>
          <EditOutlined
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
        </button>
        <button
          className={classNames(cn.actionButton, cn.removeButton)}
          onClick={onRemove}
        >
          <DeleteOutlined
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
        </button>
      </div>
    </div>
  )
}

export default NoteCard
